import { render, staticRenderFns } from "./VMealItem.vue?vue&type=template&id=2539dcc6&"
import script from "./VMealItem.vue?vue&type=script&lang=js&"
export * from "./VMealItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports